import Cookie from 'js-cookie';
import React from 'react';
import { IStofaCartConfig } from '../../index';
import { InfrastructureOwner, TechnologyType } from '../models/sows';

export const HBO_TITLE = 'HBO Nordic';
export const HBO_RECURRENT_PRICE = 89;

export const APPLE_TV_TITLE = 'Apple TV 4K';
export const APPLE_TV_PRICE = 999;

export const CHROMECAST_TITLE = 'Chromecast 3';
export const CHROMECAST_PRICE = 199;

export const CHROMECAST_GOOGLE_TV_TITLE = 'Chromecast med Google TV';
export const CHROMECAST_GOOGLE_TV_PRICE = 479;

export const TV_BOKS_TITLE = 'Stofa tv-boks';
export const TV_BOKS_RECURRENT_PRICE = 30;

export const STANDARD_PRICES = {
    initial_fee: 299,
    initial_tv_fee: 495,
    shipment: 0,
    recurrent: 369,
    administration_quarterly: 10,
};

export type STREAMING_CAMPAIGN_TYPE = 'TV2PLAY' | 'HBOMAX';

export const STREAMING_CAMPAIGN_PRODUCT_TITLES: Record<
    STREAMING_CAMPAIGN_TYPE,
    string
> = {
    TV2PLAY: 'TV 2 Play Favorit med reklamer',
    HBOMAX: 'HBO Max',
};

export const STREAMING_CAMPAIGN_PRICES: Record<
    STREAMING_CAMPAIGN_TYPE,
    number
> = {
    TV2PLAY: 129,
    HBOMAX: 79,
};

export const STREAMING_CAMPAIGN_CODES: Record<
    InfrastructureOwner,
    { [Key in TechnologyType]?: Record<STREAMING_CAMPAIGN_TYPE, string> }
> = {
    eniig: { fiber: { TV2PLAY: 'E-TV129957', HBOMAX: 'E-TV129955' } },
    stofa: {
        fiber: { TV2PLAY: 'TV2_PLAY_FAVORIT_6MD', HBOMAX: 'HBOMAX_6_MD' },
        coax: { TV2PLAY: '1127', HBOMAX: '1128' },
    },
    // Todo
    cerillion: {
        fiber: { TV2PLAY: 'TV2_PLAY_FAVORIT_6MD', HBOMAX: 'HBOMAX_6_MD' },
        coax: { TV2PLAY: '1127', HBOMAX: '1128' },
    },
};

export const MINIMUM_SPEEDS: { [index: string]: string } = {
    NAT0042: '10/1',
    NAT0043: '20/1',
    NAT0044: '30/5',
    NAT0045: '40/5',
    X22170: '900/900',
    X05: '900/900',
    X22190: '900/100',
};

export const SPEED_INFO_CONTENT: {
    [id: string]: { title: string; text: any };
} = {
    // Mikro
    '30': {
        title: 'Til den lille husstand med begrænset brug',
        text: (
            <ul>
                <li>Din husstand har et lavt netforbrug</li>
                <li>
                    Du mest bruger internettet til mails, læse nyheder, bruge
                    sociale medier og streame tv, film og musik
                </li>
                <li>
                    Det er nok, at der kun er én eller to personer, der kan
                    streame på samme tid
                </li>
            </ul>
        ),
    },
    // Mini (findes ikke!)
    '50': {
        title: 'Til almindeligt netforbrug',
        text: (
            <ul>
                <li>Din husstand har et almindeligt netforbrug</li>
                <li>
                    Du bruger mest nettet til mails, sociale medier og
                    streaming, samt til at uploade billeder/film
                </li>
                <li>2-3 personer kan streame eller game samtidigt</li>
            </ul>
        ),
    },
    '100': {
        title:
            'Til den lille husstand, onlinesurferen og den lejlighedsvise streamer.',
        text: <ul></ul>,
    },
    // Midi
    '200': {
        title: 'Til den entusiastiske streamer og effektive hjemmearbejder.',
        text: <ul></ul>,
    },
    // Maxi
    '300': {
        title: 'Til den entusiastiske streamer og effektive hjemmearbejder.',
        text: <ul></ul>,
    },
    // Maxi
    '500': {
        title: 'Til den store husstand og den seriøse streamer.',
        text: <ul></ul>,
    },
    '1000': {
        title: 'Til den digitale husstand og den fartglade gamer.',
        text: <ul></ul>,
    },
};

if (!window.StofaCartConfig) {
    window.StofaCartConfig = {
        activeTVCampaign: null,
        activeInternetCampaign: 'april2023InternetTrim',
        cartPath: '/cart.html',
        broadbandPath: '/broadband.html',
        broadbandStudieKampagne2021Path: '/broadband-studiekampagne2021.html',
        TVVaelgSelvPath: '/tvvaelgselv.html',
        TVPackagesPath: '/tvpakker.html',
    } as IStofaCartConfig;
}

export const ACTIVE_INTERNET_CAMPAIGN_OVERRIDE =
    'ACTIVE_INTERNET_CAMPAIGN_OVERRIDE';

export const ACTIVE_TV_CAMPAIGN_OVERRIDE = 'ACTIVE_TV_CAMPAIGN_OVERRIDE';

export const getConfig = (): IStofaCartConfig => {
    const localInternetCampaignOverride = document
        .querySelector('[data-internet-campaign-override]')
        ?.getAttribute('data-internet-campaign-override');

    const activeInternetCampaign =
        localInternetCampaignOverride ||
        Cookie.get(ACTIVE_INTERNET_CAMPAIGN_OVERRIDE) ||
        window.StofaCartConfig.activeInternetCampaign;

    return { ...window.StofaCartConfig, activeInternetCampaign };
};
